const { default: DataService } = require("./DataService");

class UserDataService extends DataService {
    constructor() {
        super("user")
    }

    getList(keyword, currentPage, perPage) {
        return super.getList(keyword, currentPage, perPage)
            .then((data) => {
                return {
                    users: data.data.user_list !== null && data.data.errorMessage === undefined ? data.data.user_list : [],
                    totalPages: data.data.total_user < perPage ? 1 : Math.ceil(data.data.total_user / perPage),
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    update(item) {
        const body = Object.assign({}, item)
        if (body.password === '' || body.password === 'undefined') {
            delete body.password;
        }

        return super.update(body);
    }

    disable(item) {
        const body = { 
            user_id: item.user_id,
            username: item.username,
            status: 1
        }
        
        return super.update(body);
    }
}

export default UserDataService;